import { useEffect } from 'react';
import { Divider, Grid, useAppDispatch, useTheme } from '../../../base';
import { reportsActions } from '../../../actions';
import { FunnelView, ReportPeriod } from '../../../common';
import {
    IReportsFilterValue,
    IFetchFunnelParams,
} from '../../../common/interfaces/reports.interfaces';

import ReportsFilter from '../ReportsFilter';
import CompanyWideView from './CompanyWideView';
import StageConversionRates from './StageConversionRates';
import ConversionBarChart from './StageConversionRates/ConversionBarChart';
import DropOffRates from './DropOffRates';
import OverallFunnelConversion from './OverallFunnelConversion';
import { StyledFunnelWrapper } from './RecruitmentFunnel.styles';

const RecruitmentFunnel = () => {
    const dispatch = useAppDispatch();
    const theme = useTheme();

    useEffect(() => {
        dispatch(
            reportsActions.fetchFunnel({
                view: FunnelView.COMPANY,
                period: ReportPeriod.YEAR,
            })
        );
    }, [dispatch]);

    const handleFilterChange = (filterValue: IReportsFilterValue) => {
        const params: IFetchFunnelParams = {
            view: FunnelView.COMPANY,
        };

        if (filterValue.jobId) {
            params.view = FunnelView.JOB;
            params.id = filterValue.jobId;
        } else if (filterValue.recruiterId) {
            params.view = FunnelView.RECRUITER;
            params.id = filterValue.recruiterId;
        }

        if (
            filterValue.timeFrame === ReportPeriod.CUSTOM &&
            filterValue.customDateRange
        ) {
            params.from_date = filterValue.customDateRange.fromDate;
            params.to_date = filterValue.customDateRange.toDate;
        } else if (filterValue.timeFrame) {
            params.period =
                filterValue.timeFrame as IFetchFunnelParams['period'];
        }

        dispatch(reportsActions.fetchFunnel(params));
    };

    return (
        <StyledFunnelWrapper>
            <ReportsFilter
                onChange={handleFilterChange}
                defaultTimeFrame={ReportPeriod.YEAR}
            />
            <Divider sx={{ borderColor: theme.palette.grey[300] }} />
            <CompanyWideView />
            <Divider sx={{ borderColor: theme.palette.grey[300] }} />
            <Grid container spacing={3} sx={{ padding: theme.spacing(2, 3), alignItems: 'stretch' }}>
                <Grid item xs={12} md={6} sx={{ display: 'flex' }}>
                    <StageConversionRates />
                </Grid>
                <Grid item xs={12} md={6}>
                    <ConversionBarChart />
                    <Grid
                        container
                        spacing={3}
                        sx={{
                            marginTop: 0,
                        }}
                    >
                        <Grid item xs={12} sm={6} sx={{ display: 'flex' }}>
                            <DropOffRates />
                        </Grid>
                        <Grid item xs={12} sm={6} sx={{ display: 'flex' }}>
                            <OverallFunnelConversion />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </StyledFunnelWrapper>
    );
};

export default RecruitmentFunnel;
